import React from 'react'
import { Text, View } from 'react-native'

import { body2, h4 } from '@ui-kit/core/typography'

import { informationList } from './styles'
import type { ListProps } from './types'

const InformationList = (props: ListProps): JSX.Element => {
  const { container, item, titleContainer, title } = informationList()
  return (
    <View className={container()}>
      {props.listData.map((listItemData) => {
        return (
          <View key={listItemData.id} className={item()}>
            <View className={titleContainer()}>
              {listItemData.icon}
              <Text className={h4({ className: title() })}>{listItemData.title}</Text>
            </View>
            <Text className={body2({ emphasis: 'medium' })}>{listItemData.description}</Text>
          </View>
        )
      })}
    </View>
  )
}

export default InformationList
